import ScrollToTop from "./app/elements/scroll-to-top";
import RootLayout from "./layouts/root-layout";
import Loader from "./app/elements/loader";
import WhatsAppChatbot from "./app/elements/whatsapp-chatbot";
import TawkTo from "./app/elements/tawk-to";
import CookieConsent from "./app/elements/cookie-consent";
import { useState } from "react";

function App() {

  const [isLoading, setLoading] = useState(true);

  setTimeout(() => {
    setLoading(false);
  }, 500);

  return (
    <>
      {isLoading && <Loader />}
      <ScrollToTop />
      <RootLayout />
      <WhatsAppChatbot />
      <TawkTo />
      <CookieConsent />
    </>
  );
}

export default App;